import Layout from "@/components/layout/layout";
import Game from "../components/mini-game/game";
const MiniGamePage = () => {
  return (
    <div>
      <Layout>
        <Game />
      </Layout>
    </div>
  );
};

export default MiniGamePage;
